import { render, staticRenderFns } from "./OptometristPackage.vue?vue&type=template&id=102ca983&scoped=true&"
import script from "./OptometristPackage.vue?vue&type=script&lang=js&"
export * from "./OptometristPackage.vue?vue&type=script&lang=js&"
import style0 from "./OptometristPackage.vue?vue&type=style&index=0&id=102ca983&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102ca983",
  null
  
)

export default component.exports